"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setShouldShowFinalizePaymentComponent = exports.selectFinalizePayment = exports.finalizePaymentSlice = exports.fetchFinalizeInitialPayment = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
var _eventDispatcher = _interopRequireWildcard(require("../util/eventDispatcher"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const initialState = {
  loading: false,
  payment: {
    paymentMethod: null,
    currency: null
  },
  error: null,
  shouldShowFinalizePaymentComponent: false
};
const fetchFinalizeInitialPayment = exports.fetchFinalizeInitialPayment = (0, _toolkit.createAsyncThunk)('finalizeInitialPayment', async (_ref, _ref2) => {
  let {
    orderId,
    details
  } = _ref;
  let {
    rejectWithValue
  } = _ref2;
  try {
    const {
      payment
    } = await (0, _api.finalizeInitialPayment)(orderId, details);
    return payment;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const finalizePaymentSlice = exports.finalizePaymentSlice = (0, _toolkit.createSlice)({
  name: 'finalizeInitialPayment',
  initialState,
  reducers: {
    setShouldShowFinalizePaymentComponent(state, action) {
      state.shouldShowFinalizePaymentComponent = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchFinalizeInitialPayment.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchFinalizeInitialPayment.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.payment = action.payload;
      state.shouldShowFinalizePaymentComponent = true;
      const {
        payload
      } = action;
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_SUCCESSFUL, {
        payload
      });
    });
    builder.addCase(fetchFinalizeInitialPayment.rejected, (state, _ref3) => {
      let {
        payload
      } = _ref3;
      state.loading = false;
      if (payload) {
        state.error = payload;
      }
      state.shouldShowFinalizePaymentComponent = true;
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_FAILED, {
        payload
      });
    });
  }
});
const selectFinalizePayment = state => state.finalizeInitialPayment;
exports.selectFinalizePayment = selectFinalizePayment;
const {
  setShouldShowFinalizePaymentComponent
} = finalizePaymentSlice.actions;
exports.setShouldShowFinalizePaymentComponent = setShouldShowFinalizePaymentComponent;
var _default = exports.default = finalizePaymentSlice.reducer;